module.exports = __webpack_public_path__ + "img/annotation_default.df5060fc.svg";